'use client'

import GoogleAdSense from '@/app/[locale]/[roomId]/components/GoogleAdSense'
import World from '@/app/[locale]/[roomId]/components/World'
import WorldInfoDetails from '@/app/[locale]/[roomId]/components/WorldInfoDetails'
import WorldInfoPanel from '@/app/[locale]/[roomId]/components/WorldInfoPanel'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useUAContext } from '@/context/UAContext'
import { useScrollLock } from '@/hooks/useScrollLock'
import { getAdConfig, isGoogleAdEnabledByGenre } from '@/lib/advertising'
import { cn } from '@/lib/utils'

function WorldContentDetail() {
  const { isMobileLandscape } = useUAContext()
  const { setScrollLock } = useScrollLock()
  const { roomData } = useCheckEnterRoomContext()
  const genres = roomData.tags

  const { isGoogleAdEnabled } = getAdConfig()
  const isAdEnabledByGenre = isGoogleAdEnabledByGenre(genres)
  const shouldShowAd = isGoogleAdEnabled || isAdEnabledByGenre

  return (
    <div
      className={cn(
        '3xl:max-w-[1440px] 3xl:min-w-[1440px] flex w-full flex-col gap-4 md:max-w-full md:min-w-full md:gap-6 lg:col-start-1 lg:row-start-1 lg:max-w-[75vw] lg:min-w-[75vw]',
        {
          'grid grid-cols-2': isMobileLandscape,
        },
      )}
    >
      <World className="aspect-[16/9]" setScrollLock={setScrollLock} />
      <WorldInfoPanel />

      {shouldShowAd && (
        <div className={cn(isMobileLandscape ? 'order-last col-span-2' : 'order-2')}>
          <GoogleAdSense />
        </div>
      )}

      {!isMobileLandscape && <WorldInfoDetails />}
    </div>
  )
}

export default WorldContentDetail
